import React from "react";
import { useRoutes } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { SettingsProvider } from "./app/contexts/SettingsContext";
import { MatxTheme } from "./app/components/theme";
import { AuthProvider } from "./app/contexts/AuthContext";
import Routers from "./app/routers/Routers";
import { AlertNotification } from "app/components/template/notification";
import { FabWhatsApp } from "app/components/template/partials";

export default function App({ store, persistor }) {
  const content = useRoutes(Routers);
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={<div>Loading ... </div>}>
        <React.Suspense fallback={<div>Loading ... </div>}>
          <SettingsProvider>
            <MatxTheme>
              <AuthProvider>{content}</AuthProvider>
              <AlertNotification />
              <FabWhatsApp />
            </MatxTheme>
          </SettingsProvider>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
